import React from "react";
import {ListItem} from "../list-item/reportListItem";
import {TableWrapper} from "../../../../../shared/layout";
import {TableLoader} from "../../../../../shared/widgets";
import {
    frequencyByRegionTemplateStrings
} from "../../utils";
export const ListViewFrequency = (props)=> {

    const templateStrings = frequencyByRegionTemplateStrings;

    return (
        <TableWrapper id="report-list">
            <TableWrapper.Header columns={templateStrings} onSortToggle={props.onSortChange} type={'deviceFrequency'}/>
            {props.loading && <TableLoader loading={props.loading}
                                           colSpan={Object.keys(templateStrings).length}/>}
            {!props.loading && <tbody>
            {props.content && props.content.map((data, index) => {
                return <ListItem key={index} item={data} columns={templateStrings}
                                 keyId="vehicleNo" keyId2="deviceId"/>;
            })}
            {(!props.content || (props.content && props.content.length == 0)) &&
            <tr className="gradeA odd noDataStyle" role="row">
                <td className="sorting_1"
                    colSpan="6">{!props.content ? "No Data Found" : "GPS Matrix service is not enabled!"}</td>
            </tr>
            }
            </tbody>}
        </TableWrapper>)
};